/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/return-await */
/* eslint-disable arrow-body-style */
/* eslint-disable react/require-default-props */
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { PriorAuthorizationDomain, PriorAuthorizationDomainDetails, ProcedureDetailDomain } from '../../interfaces/PriorAuthorizationDomain';
import SSORouterService from '../../services/SSORouter/ssoRouter.service';

interface ISSORouterProps {
  priorAuthDomainObj: PriorAuthorizationDomain,
  isSummaryPage: boolean,
  isDisabledCompleteRequestButton?: boolean
}

const GetEncryptedDataForPortal2 = async () => {
  return await SSORouterService.get();
};

export const SSORouter: React.FC<ISSORouterProps> = (props: ISSORouterProps) => {
  const [authorizationDomainDetails, setAuthorizationDomainDetails] = useState<Array<PriorAuthorizationDomainDetails>>([]);
  const [areAllProcedurecodeEviCoreDelegated, setAreAllProcedurecodeEviCoreDelegated] = useState<boolean>(false);
  const [areAnyProcedurecodeEviCoreDelegated, setAreAnyProcedurecodeEviCoreDelegated] = useState<boolean>(false);
  const [eviCoreDelegatedProcedureCodes, setEviCoreDelegateAllProcedureCodes] = useState<Array<ProcedureDetailDomain>>([]);

  if (props.isDisabledCompleteRequestButton === undefined) {
    props.isDisabledCompleteRequestButton = false;
  }

  const InitiateSSO = async () => {
    const portal2Url = process.env.REACT_APP_PORTAL2_REDIRECT_URI_NOT_ENCODED || '';
    const respose = await GetEncryptedDataForPortal2();
    goToExternalURL(portal2Url, respose);
  };

  function goToExternalURL(url:string, token:string) {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = url;

    const hiddenFieldSample1 = document.createElement('input');
    hiddenFieldSample1.type = 'hidden';
    hiddenFieldSample1.name = 'key';
    hiddenFieldSample1.value = token;
    form.appendChild(hiddenFieldSample1);

    document.body.appendChild(form);
    form.submit();
  }

  useEffect(() => {
    const authorizationDomainDetailsTemp = _.cloneDeep(props.priorAuthDomainObj?.priorAuthorizationDomianDetails);
    const allProcedureCodesTemp: Array<ProcedureDetailDomain> = _.flatten(_.map(authorizationDomainDetailsTemp, 'proceduresDetails'));

    // if true route to Portal 2.0
    const allProcEviCoreDelegated = _.every(allProcedureCodesTemp, { processedBy: 'E' });
    setAreAllProcedurecodeEviCoreDelegated(allProcEviCoreDelegated);

    // if any is true and all is false then
    if (allProcEviCoreDelegated === false) {
      const anyProcEviCoreDelegated = _.some(allProcedureCodesTemp, { processedBy: 'E' });
      setAreAnyProcedurecodeEviCoreDelegated(anyProcEviCoreDelegated);

      // All eviCore delegated procedure code
      setEviCoreDelegateAllProcedureCodes(_.filter(allProcedureCodesTemp, { processedBy: 'E' }));

      if (authorizationDomainDetailsTemp && anyProcEviCoreDelegated === true) {
        _.each(authorizationDomainDetailsTemp, function (service: PriorAuthorizationDomainDetails) {
          _.remove(service.proceduresDetails, (code: ProcedureDetailDomain) => { return code.processedBy !== 'E'; });
        });
        // Remove auths where  procedure code array is empty
        _.remove(authorizationDomainDetailsTemp, function (auths) { return auths.proceduresDetails.length === 0; });

        setAuthorizationDomainDetails(authorizationDomainDetailsTemp);
      }
    }
  }, [props.priorAuthDomainObj?.priorAuthorizationDomianDetails]);

  // Auto redirect logic can come here
  useEffect(() => {
    if (areAllProcedurecodeEviCoreDelegated === true) {
      InitiateSSO();
    }
  }, [areAllProcedurecodeEviCoreDelegated]);

  return (
    <div>
      {/* Request submit page */}
      {
                    areAllProcedurecodeEviCoreDelegated === false
                && areAnyProcedurecodeEviCoreDelegated === true
                && props.isSummaryPage === false
                && <div>
                  <h4>Cigna Precertification Request </h4>
                  <p data-testid="EDelegatedCPTPCodeIntakeMessage">
                    Please fill out the information below. Once you review and submit,
                    you will be directed to the EviCore system where you will need to
                    re-enter the information for the following procedure code(s):
                    <span id="collapseLink" className="text-truncate">
                      {
                                eviCoreDelegatedProcedureCodes.map((code: ProcedureDetailDomain, index: number) => {
                                  return <span key={index} data-testid="EDelegatedCPTPCode" className=" fw-bold mb-0">
                                    {code.procedureCode}
                                    {' '}
                                    {index !== eviCoreDelegatedProcedureCodes.length - 1 ? ',' : ''}
                                  </span>;
                                })
                            }

                    </span>

                  </p>
                </div>
            }
      {/* Request summary page */}
      {
                    areAllProcedurecodeEviCoreDelegated === false
                && areAnyProcedurecodeEviCoreDelegated === true
                && props.isSummaryPage === true
                && <div className="form-group s-provider mb-4 col-12">
                  <h4>Evicore Precertification Required</h4>
                  <span className="font-size-sm">Part of your request includes procedure code(s) that need to be completed through Evicore.</span>
                  <div>Click the "Complete Request" button below to finish this request.</div>
                  <div className="card mt-3 mb-2">
                    <ul className="list-group list-group-flush">
                      {
                                authorizationDomainDetails.map(
                                  (auth: PriorAuthorizationDomainDetails) => {
                                    return (
                                      <li data-testid="EDelegatedAuthRequest" key={auth.serviceRequestId} className="list-group-item">
                                        <div className="form-group service-1 mb-0">
                                          <h5>
                                            <strong data-testid="ServiceAuthType">
                                              {auth.authorizationType}
                                              {' '}
                                              -
                                              {' '}
                                              {auth.typeOfServiceDescription}
                                            </strong>
                                          </h5>
                                        </div>
                                        <div className="form-group mb-0">
                                          <div id="myTabContent" className="tab-content mt-1">
                                            <div className="tab-pane fade show active">
                                              <div className="table-full-width table-responsive ">
                                                <table className="table font-size-sm  rounded sortable-table table-bordered table-hover table-striped" summary="Procedures">
                                                  <thead>
                                                    <tr>
                                                      <th scope="col" className="align-top w-20">Procedure Code </th>
                                                      {' '}
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {
                                                                            auth.proceduresDetails.map((procedureCode: ProcedureDetailDomain) => {
                                                                              return (
                                                                                <tr data-testid="EDelegatedCPTCode" key={procedureCode.procedureCode}>
                                                                                  <td data-testid="Code">{procedureCode.procedureCode}</td>
                                                                                </tr>
                                                                              );
                                                                            })
                                                                        }
                                                  </tbody>
                                                </table>
                                              </div>
                                            </div>
                                          </div>

                                        </div>
                                      </li>

                                    );
                                  },
                                )
                            }

                    </ul>
                    <div id="nextsteps" className=" p-3">
                      <div className="mr-3">
                        <button type="button" data-testid="InitiateSSOButton" className="btn btn-sm btn-primary mr-2" onClick={InitiateSSO} disabled={props.isDisabledCompleteRequestButton}>
                          Complete Request
                          {' '}
                          <i className="fa-external-link-alt fas pl-2 pr-2" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
            }

    </div>
  );
};

export default SSORouter;
